<template>
    <div class="cardWrapper">
        <div class="card">
            <div class="cover">
                <img :src="data.cover" alt="">
            </div>
            <div class="info">
                <div class="title">{{data.title}}</div>
                <div class="time">开始日期:
                    <div>{{formatActivityDate1(data.startTime)}}</div>
                </div>
                <div class="time">结束日期:
                    <div>{{formatActivityDate1(data.endTime)}}</div>
                </div>
                <div class="address">{{data.address}}</div>
                <div class="detail" @click="handleDetail">查看详情</div>
                <button class="button" @click="toGet">去领票</button>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapMutations} from 'vuex'
    import {formatDate} from '@/utils/utils'
    export default {
        name: "ContentCard",
        props: {
            data: {
                type: Object,
                default: ()=>{}
            }
        },
        methods: {
            ...mapMutations(["setToastShow", "setClearTimer", "setToastContent"]),
            handleDetail(){
                this.$emit("on-click")
                // this.setToastShow(true);
                // this.setClearTimer(true);
                // this.setToastContent({toastType: 11, list: {name: "", content: {cover, imageAlbum, title, address, startTime, endTime, detail}}, closeColor: 'white'});
            },
            toGet(){
                this.$emit("to-get")
            },
            formatActivityDate1(date){
                return formatDate(date, 'yyyy.MM.dd hh:mm:ss')
            },
            formatActivityDate2(date){
                return formatDate(date, 'M.d')
            }
        }
    }
</script>

<style scoped lang="less">
    .cardWrapper{
        width: 8.7rem;
        height: 6.3rem;
        margin-right: .35rem;
        padding: .13rem .24rem .24rem;
        background-color: #fff;
        box-shadow: 0rem 0.11rem 0.53rem 0rem rgba(63, 142, 247, 0.13);
        border-radius: 0.16rem;

        .card{
            display: flex;
            height: 100%;
        }
        .cover{
            display: flex;
            align-items: center;
            border-radius: 0.16rem;
            margin-right: .29rem;
            img{
                /*width: 100%;*/
                /*height: 100%;*/
                width: 3.7rem;
                border-radius: 0.16rem;
            }
        }
        .info{
            flex: 1;
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
            .title{
                height: 1.67rem;
                font-size: 0.43rem;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 800;
                color: #333333;
                /*line-height: 0.64rem;*/
                /*position: absolute;*/
                top: 0;
                width: 100%;
                word-break: break-all;
                line-height: .55rem;
                display: flex;
                align-items: center;
            }
            .time{
                font-size: 0.35rem;
                color: #666666;
                line-height: 0.5rem;
                /*position: absolute;*/
                /*top: 1.65rem;*/
                width: 100%;
                word-break: break-all;
            }
            .address{
                font-size: 0.35rem;
                color: #666666;
                line-height: 0.37rem;
                line-height: .45rem;
                /*position: absolute;*/
                /*top: 2.24rem;*/
                width: 100%;
                word-break: break-all;
            }
            .detail{
                font-size: 0.32rem;
                color: #3872F6;
                line-height: 0.4rem;
                /*position: absolute;*/
                /*top: 3.2rem;*/
            }
            .button{
                width: 100%;
                height: .83rem;
                background-color: rgba(90, 197, 250, 1);
                color: #fff;
                font-size: 0.43rem;
                font-weight: 500;
                line-height: 0.43rem;
                border-radius: .11rem;
                /*position: absolute;*/
                /*bottom: 0;*/
            }
        }
        .scrollUser{
            height: 4.45rem;
            width: 100%;
        }
    }
</style>
